// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-fill-available {
  width: -webkit-fill-available;
}

.hand-raise-animation {
  animation: handRaise 1s ease-in-out;
}

@keyframes handRaise {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

/* Active menu item styles */
li.active-menu-item,
li.active-menu-item a,
div.active-menu-item {
  background-color: #e6f7fa;
  background-color: var(--color-primary-light, #e6f7fa);
  color: #f17a20;
  color: var(--color-primary, #f17a20);
  font-weight: 700;
  position: relative;
  border-radius: 8px;
}

/* Submenu active item styles */
ul.ml-8 li.active-menu-item,
ul.ml-8 li.active-menu-item a {
  background-color: transparent;
  color: #f17a20;
  color: var(--color-primary, #f17a20);
  font-weight: 700;
}

/* Remove the left accent bar for all active items */
ul.ml-8 li.active-menu-item::before,
li.active-menu-item::before,
div.active-menu-item::before {
  display: none;
}

li.active-menu-item:hover,
li.active-menu-item a:hover,
div.active-menu-item:hover {
  border-radius: 8px;
}

/*
 * MenuTeacher — antd Menu (components/MenuTeacher). Scope bằng .teacher-sidebar-menu.
 * Chuẩn: bình thường = chữ xám + icon xám; hover = nền xám nhẹ; active = nền cam, chữ + icon trắng.
 */

/* Căn bản: layout + chữ xám. */
.teacher-sidebar-menu.ant-menu .ant-menu-item,
.teacher-sidebar-menu.ant-menu .ant-menu-submenu-title,
.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item {
  height: 40px !important;
  line-height: 40px !important;
  color: #828282 !important;
  background-color: transparent !important;
}
.teacher-sidebar-menu.ant-menu .ant-menu-item,
.teacher-sidebar-menu.ant-menu .ant-menu-submenu-title,
.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item {
  font-weight: 700;
  border-radius: 8px;
  margin-top: 0;
  margin-bottom: 8px;
}

/* Mặc định: icon Lucide cùng màu chữ (xám). */
.teacher-sidebar-menu.ant-menu
  .ant-menu-item:not(.ant-menu-item-selected)
  .ant-menu-item-icon
  svg,
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu:not(.ant-menu-submenu-selected)
  > .ant-menu-submenu-title
  .ant-menu-item-icon
  svg,
.teacher-sidebar-menu.ant-menu
  .ant-menu-sub
  .ant-menu-item:not(.ant-menu-item-selected)
  .ant-menu-item-icon
  svg {
  color: #828282 !important;
}

/* Mục con: khoảng cách dọc. */
.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item {
  margin-bottom: 4px;
}

/* Active: nền primary, chữ + icon trắng. */
.teacher-sidebar-menu.ant-menu .ant-menu-item-selected,
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu-selected
  > .ant-menu-submenu-title {
  background-color: #f17a20 !important;
  background-color: var(--color-primary, #f17a20) !important;
  color: #ffffff !important;
}
.teacher-sidebar-menu.ant-menu .ant-menu-item-selected,
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu-selected
  > .ant-menu-submenu-title {
  border-radius: 8px;
}
.teacher-sidebar-menu.ant-menu .ant-menu-item-selected .ant-menu-item-icon svg,
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu-selected
  > .ant-menu-submenu-title
  .ant-menu-item-icon
  svg {
  color: #ffffff !important;
}

.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item-selected {
  background-color: #f17a20 !important;
  background-color: var(--color-primary, #f17a20) !important;
  color: #ffffff !important;
}
.teacher-sidebar-menu.ant-menu
  .ant-menu-sub
  .ant-menu-item-selected
  .ant-menu-item-icon
  svg {
  color: #ffffff !important;
}

/* Hover: mục chưa chọn — nền xám nhẹ, chữ + icon vẫn xám. */
.teacher-sidebar-menu.ant-menu
  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(
    .ant-menu-item-selected
  ),
.teacher-sidebar-menu.ant-menu
  .ant-menu-sub
  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(
    .ant-menu-item-selected
  ) {
  background-color: #f0f0f0 !important;
  color: #828282 !important;
}
.teacher-sidebar-menu.ant-menu
  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(.ant-menu-item-selected)
  .ant-menu-item-icon
  svg,
.teacher-sidebar-menu.ant-menu
  .ant-menu-sub
  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(.ant-menu-item-selected)
  .ant-menu-item-icon
  svg {
  color: #f17a20 !important;
  color: var(--color-primary, #f17a20) !important;
}

/* Tiêu đề submenu (chưa active con): hover nền xám nhẹ, chữ xám, icon cam. */
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu:not(.ant-menu-submenu-selected)
  > .ant-menu-submenu-title:hover {
  background-color: #f0f0f0 !important;
  color: #828282 !important;
}
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu:not(.ant-menu-submenu-selected)
  > .ant-menu-submenu-title:hover
  .ant-menu-item-icon
  svg {
  color: #f17a20 !important;
  color: var(--color-primary, #f17a20) !important;
}

/* Mục đang active: hover tối nền cam một chút, vẫn chữ + icon trắng. */
.teacher-sidebar-menu.ant-menu .ant-menu-item-selected:hover,
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu-selected
  > .ant-menu-submenu-title:hover,
.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item-selected:hover {
  color: #ffffff !important;
  background-color: #d96818 !important;
}
.teacher-sidebar-menu.ant-menu
  .ant-menu-item-selected:hover
  .ant-menu-item-icon
  svg,
.teacher-sidebar-menu.ant-menu
  .ant-menu-submenu-selected
  > .ant-menu-submenu-title:hover
  .ant-menu-item-icon
  svg,
.teacher-sidebar-menu.ant-menu
  .ant-menu-sub
  .ant-menu-item-selected:hover
  .ant-menu-item-icon
  svg {
  color: #ffffff !important;
}

/* Breadcrumb styles */
.ant-breadcrumb {
  font-size: 14px;
}

.ant-breadcrumb a {
  color: #f17a20;
  font-weight: 500;
}

.ant-breadcrumb a:hover {
  color: #005d7a;
}

.ant-breadcrumb-separator {
  margin: 0 8px;
  color: #666;
}

.ant-breadcrumb ol {
  display: flex;
  align-items: center;
}

.ant-breadcrumb .anticon {
  font-size: 12px;
}

/* Home icon specific styles */
.ant-breadcrumb a svg {
  vertical-align: middle;
  color: #f17a20;
}
`, "",{"version":3,"sources":["webpack://./src/components/LayoutTeacher/layout.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;;;EAGE,yBAAqD;EAArD,qDAAqD;EACrD,cAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;;EAEE,6BAA6B;EAC7B,cAAoC;EAApC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE;;AAEF,+BAA+B;AAC/B;;;EAKE,uBAAuB;EACvB,4BAA4B;EAG5B,yBAAyB;EACzB,wCAAwC;AAC1C;AAXA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAGlB,aAAa;EACb,kBAAkB;AAGpB;;AAEA,8CAA8C;AAC9C;;;;;;;;;;;;;;EAcE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;;;;EAIE,oCAA0D;EAA1D,0DAA0D;EAC1D,yBAAyB;AAE3B;AAPA;;;;EAME,kBAAkB;AACpB;AACA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,oCAA0D;EAA1D,0DAA0D;EAC1D,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;;;;;;;;;EASE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;;;;;;;EASE,yBAA+C;EAA/C,+CAA+C;AACjD;;AAEA,6EAA6E;AAC7E;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;;;EAKE,yBAA+C;EAA/C,+CAA+C;AACjD;;AAEA,uEAAuE;AACvE;;;;;EAKE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;;;;;;;;;;;;;;EAcE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".w-fill-available {\n  width: -webkit-fill-available;\n}\n\n.hand-raise-animation {\n  animation: handRaise 1s ease-in-out;\n}\n\n@keyframes handRaise {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.2);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Active menu item styles */\nli.active-menu-item,\nli.active-menu-item a,\ndiv.active-menu-item {\n  background-color: var(--color-primary-light, #e6f7fa);\n  color: var(--color-primary, #f17a20);\n  font-weight: 700;\n  position: relative;\n  border-radius: 8px;\n}\n\n/* Submenu active item styles */\nul.ml-8 li.active-menu-item,\nul.ml-8 li.active-menu-item a {\n  background-color: transparent;\n  color: var(--color-primary, #f17a20);\n  font-weight: 700;\n}\n\n/* Remove the left accent bar for all active items */\nul.ml-8 li.active-menu-item::before,\nli.active-menu-item::before,\ndiv.active-menu-item::before {\n  display: none;\n}\n\nli.active-menu-item:hover,\nli.active-menu-item a:hover,\ndiv.active-menu-item:hover {\n  border-radius: 8px;\n}\n\n/*\n * MenuTeacher — antd Menu (components/MenuTeacher). Scope bằng .teacher-sidebar-menu.\n * Chuẩn: bình thường = chữ xám + icon xám; hover = nền xám nhẹ; active = nền cam, chữ + icon trắng.\n */\n\n/* Căn bản: layout + chữ xám. */\n.teacher-sidebar-menu.ant-menu .ant-menu-item,\n.teacher-sidebar-menu.ant-menu .ant-menu-submenu-title,\n.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item {\n  font-weight: 700;\n  border-radius: 8px;\n  height: 40px !important;\n  line-height: 40px !important;\n  margin-top: 0;\n  margin-bottom: 8px;\n  color: #828282 !important;\n  background-color: transparent !important;\n}\n\n/* Mặc định: icon Lucide cùng màu chữ (xám). */\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-item:not(.ant-menu-item-selected)\n  .ant-menu-item-icon\n  svg,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-submenu:not(.ant-menu-submenu-selected)\n  > .ant-menu-submenu-title\n  .ant-menu-item-icon\n  svg,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-sub\n  .ant-menu-item:not(.ant-menu-item-selected)\n  .ant-menu-item-icon\n  svg {\n  color: #828282 !important;\n}\n\n/* Mục con: khoảng cách dọc. */\n.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item {\n  margin-bottom: 4px;\n}\n\n/* Active: nền primary, chữ + icon trắng. */\n.teacher-sidebar-menu.ant-menu .ant-menu-item-selected,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-submenu-selected\n  > .ant-menu-submenu-title {\n  background-color: var(--color-primary, #f17a20) !important;\n  color: #ffffff !important;\n  border-radius: 8px;\n}\n.teacher-sidebar-menu.ant-menu .ant-menu-item-selected .ant-menu-item-icon svg,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-submenu-selected\n  > .ant-menu-submenu-title\n  .ant-menu-item-icon\n  svg {\n  color: #ffffff !important;\n}\n\n.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item-selected {\n  background-color: var(--color-primary, #f17a20) !important;\n  color: #ffffff !important;\n}\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-sub\n  .ant-menu-item-selected\n  .ant-menu-item-icon\n  svg {\n  color: #ffffff !important;\n}\n\n/* Hover: mục chưa chọn — nền xám nhẹ, chữ + icon vẫn xám. */\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(\n    .ant-menu-item-selected\n  ),\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-sub\n  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(\n    .ant-menu-item-selected\n  ) {\n  background-color: #f0f0f0 !important;\n  color: #828282 !important;\n}\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(.ant-menu-item-selected)\n  .ant-menu-item-icon\n  svg,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-sub\n  .ant-menu-item:hover:not(.ant-menu-item-disabled):not(.ant-menu-item-selected)\n  .ant-menu-item-icon\n  svg {\n  color: var(--color-primary, #f17a20) !important;\n}\n\n/* Tiêu đề submenu (chưa active con): hover nền xám nhẹ, chữ xám, icon cam. */\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-submenu:not(.ant-menu-submenu-selected)\n  > .ant-menu-submenu-title:hover {\n  background-color: #f0f0f0 !important;\n  color: #828282 !important;\n}\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-submenu:not(.ant-menu-submenu-selected)\n  > .ant-menu-submenu-title:hover\n  .ant-menu-item-icon\n  svg {\n  color: var(--color-primary, #f17a20) !important;\n}\n\n/* Mục đang active: hover tối nền cam một chút, vẫn chữ + icon trắng. */\n.teacher-sidebar-menu.ant-menu .ant-menu-item-selected:hover,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-submenu-selected\n  > .ant-menu-submenu-title:hover,\n.teacher-sidebar-menu.ant-menu .ant-menu-sub .ant-menu-item-selected:hover {\n  color: #ffffff !important;\n  background-color: #d96818 !important;\n}\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-item-selected:hover\n  .ant-menu-item-icon\n  svg,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-submenu-selected\n  > .ant-menu-submenu-title:hover\n  .ant-menu-item-icon\n  svg,\n.teacher-sidebar-menu.ant-menu\n  .ant-menu-sub\n  .ant-menu-item-selected:hover\n  .ant-menu-item-icon\n  svg {\n  color: #ffffff !important;\n}\n\n/* Breadcrumb styles */\n.ant-breadcrumb {\n  font-size: 14px;\n}\n\n.ant-breadcrumb a {\n  color: #f17a20;\n  font-weight: 500;\n}\n\n.ant-breadcrumb a:hover {\n  color: #005d7a;\n}\n\n.ant-breadcrumb-separator {\n  margin: 0 8px;\n  color: #666;\n}\n\n.ant-breadcrumb ol {\n  display: flex;\n  align-items: center;\n}\n\n.ant-breadcrumb .anticon {\n  font-size: 12px;\n}\n\n/* Home icon specific styles */\n.ant-breadcrumb a svg {\n  vertical-align: middle;\n  color: #f17a20;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
